import { Link } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";

export default function Footer() {
	const { config, aspUrl } = useAppSelector((state) => state.site);

	return (
		<footer className="bg-primary-700 mt-auto print:hidden">
			<div className="mx-auto max-w-screen-2xl px-4 sm:px-6 lg:px-8">
				<div className="flex flex-wrap justify-between items-center py-2">
					<div className="text-xs text-gray-100 py-2 mr-4">
						<Link
							to={config ? config.aboutUsUrl : ""}
							target="_blank"
							rel="noopener noreferrer"
							id="footer-about-us"
							className="pr-1 no-underline text-gray-100">
							About Us
						</Link>
						<span className="pr-1"> &bull; </span>
						<Link
							to={config ? config.contactUsUrl : ""}
							target="_blank"
							rel="noopener noreferrer"
							id="footer-contact-us"
							className="pr-1 no-underline text-gray-100">
							Contact Us
						</Link>
						<span className="pr-1"> &bull; </span>
						<Link
							to={config?.privacyPolicyUrl ?? ""}
							target="_blank"
							rel="noopener noreferrer"
							id="footer-privacy-policy"
							className="pr-1 no-underline text-gray-100">
							Privacy Policy
						</Link>
						<span className="pr-1"> &bull; </span>
						<Link
							to={config?.termsOfServiceUrl ?? ""}
							target="_blank"
							rel="noopener noreferrer"
							id="footer-terms-of-service"
							className="pr-1 no-underline text-gray-100">
							Terms of Service
						</Link>
						<span className="pr-1"> &bull; </span>
						<Link
							to={aspUrl ? `${aspUrl}/ReleaseNotes` : ""}
							target="_blank"
							rel="noopener noreferrer"
							id="footer-release-notes"
							className="pr-1 no-underline text-gray-100">
							Release Notes
						</Link>
						<span className="pr-1"> &bull; </span>
						<Link
							to="/status"
							id="footer-site-status"
							className="pr-1 no-underline text-gray-100">
							Status
						</Link>
					</div>
					<div className="text-xs text-gray-100 py-2">
						<span className="block sm:inline">
							&copy;{`${new Date().getFullYear()}`} Measurement Incorporated.
						</span>{" "}
						<span className="block sm:inline">All rights reserved.</span>
					</div>
				</div>
			</div>
		</footer>
	);
}
